// Actions
import UploadAction from "@common/redux/actions/UploadAction";

// Client
import MediaClient from "@common/api/MediaClient";

const fetchCctvImages = (incidentId) => {
  UploadAction.setLoadingImages(true).then(() => {
    MediaClient.Search({ incidentId })
      .then((response) => {
        UploadAction.dispatch({ imageList: response });
      })
      .catch((error) => {
        console.error("Error fetching images: ", error);
      })
      .finally(() => UploadAction.setLoadingImages(false));
  });
};

export default fetchCctvImages;
